import { Vue, Component } from 'vue-property-decorator';

import _ from 'lodash';
import rawData from '@/data/19983881105_e93c2d8279_b.jpg.json';

import Tree from '@/components/Tree/Tree.vue';
import RadialTree from '@/components/RadialTree/RadialTree.vue';
import Dendrogram from '@/components/Dendrogram/Dendrogram.vue';
import D3Dendrogram from '@/components/D3Dendrogram/D3Dendrogram.vue';
import RadialDendrogram from '@/components/RadialDendrogram/RadialDendrogram.vue';
import RadialMiddleCircle from '@/components/RadialMiddleCircle/RadialMiddleCircle.vue';
import D3RadialMiddleCircle from '@/components/D3RadialMiddleCircle/D3RadialMiddleCircle.vue';

@Component({
  components: {
    Tree,
    RadialTree,
    Dendrogram,
    D3Dendrogram,
    RadialDendrogram,
    RadialMiddleCircle,
    D3RadialMiddleCircle
  }
})
export default class Home extends Vue {
  private renderingComponent: string = 'radial-middle-circle';

  /**
   * 컴포넌트를 바꿔주는 함수
   * @param componentName
   */
  private goComponent(componentName: string) {
    this.renderingComponent = componentName;
    console.log('componentName', componentName);
  }
}
